module.exports = __webpack_public_path__ + "static/media/profilebg.a464c192.png";